module.exports = __webpack_public_path__ + "img/bianzu13.1087259f.png";